import { FormattedRecipes } from 'types/AlgoliaResults';
import { SearchResultCard, getRecipeImages } from '..';
import { PathTranslations } from 'service/localization/getPathTranslations';
import { RatingService } from '@/service/rating/ratingService';

export const mapAlgoliaRecipeToSearchCard = (
  recipe: FormattedRecipes,
  labels: Record<string, string>,
  pathTranslations: PathTranslations,
): SearchResultCard =>
  ({
    resultType: 'recipe',
    id: recipe.id,
    title: recipe.title,
    description: recipe.description,
    categoryId: recipe.category_id,
    category: recipe.category,
    images: getRecipeImages(recipe.images),
    information: {
      preparationTime: `${recipe?.preparation_time || 0} min`,
      rating: `${RatingService.normalizeRating({ averageRatingScore: recipe?.rating?.average_rating_score, numberOfVotes: recipe?.rating?.rating_votes })?.averageRatingScore}`,
      difficulty: labels[recipe.difficulty] || null,
      totalTime: `${recipe?.total_time || recipe?.preparation_time || 0} min`,
    },
    link: {
      url: `${pathTranslations.recipe}${recipe.slug}`,
      displayName: labels.see_recipe || 'See recipe',
    },
  }) as SearchResultCard;
